var map = {
	"./ic_arbitrum_24.svg": 222,
	"./ic_avalanche_24.svg": 464,
	"./ic_bal_24.svg": 465,
	"./ic_btc_24.svg": 466,
	"./ic_busd_24.svg": 467,
	"./ic_crv_24.svg": 468,
	"./ic_dai_24.svg": 469,
	"./ic_eth_24.svg": 470,
	"./ic_frax_24.svg": 471,
	"./ic_fxs_24.svg": 472,
	"./ic_link_24.svg": 473,
	"./ic_mim_24.svg": 474,
	"./ic_mlp_24.svg": 223,
	"./ic_ppusd_24.svg": 475,
	"./ic_tcr_24.svg": 476,
	"./ic_tether_24.svg": 477,
	"./ic_uni_24.svg": 478,
	"./ic_usdc.e_24.svg": 479,
	"./ic_usdc_24.svg": 480,
	"./ic_usdt_24.svg": 481,
	"./ic_wallet_24.svg": 186,
	"./ic_weth_24.svg": 482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 726;